module.exports = require('./dist/sign.js');